import { Button } from "@/components/ui/button"
import { ProfileFiveTwoNineAccounts_QueryFragmentFragment } from "@/generated/graphql"
import { cn } from "@/lib/utils"
import { addBeneficiaryPath } from "@/novus/novus-paths"
import gql from "graphql-tag"
import { default as React } from "react"
import { Link } from "react-router-dom"
import FiveTwoNineAccountsListItem from "./FiveTwoNineAccountsListItem"

export const ProfileFiveTwoNineAccountFragment = gql(`
  fragment ProfileFiveTwoNineAccountFragment on FiveTwoNineAccount {
    id
    beneficiaryFirstName
    beneficiaryLastName
    beneficiaryBirthdate
    beneficiaryDescription
    beneficiaryPhotoUrl
    accountNumber
    program {
      id
      name
      sponsorState {
        id
        name
        abbreviation
      }
    }
  }
`)

export const ProfileFiveTwoNineAccounts_QueryFragment = gql(`
  fragment ProfileFiveTwoNineAccounts_QueryFragment on Query {
    fiveTwoNineAccounts(userId: $userId, after: $fiveTwoNineAccountsAfter, first: 6) {
      edges {
        node {
          ...ProfileFiveTwoNineAccountFragment
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`)

const FiveTwoNineAccountsList = ({
  data,
  loading,
  fetchMore,
}: {
  data: ProfileFiveTwoNineAccounts_QueryFragmentFragment["fiveTwoNineAccounts"]
  loading: boolean
  fetchMore: (after: string) => void
}) => {
  const fiveTwoNineAccounts = data?.edges
    ?.map((edge) => edge.node!)
    .filter(Boolean)
  const endCursor = data.pageInfo.endCursor
  const hasNextPage = data.pageInfo.hasNextPage

  return (
    <div>
      {fiveTwoNineAccounts.length === 0 ? (
        <div
          className={cn("flex flex-col justify-between gap-10", "md:flex-row")}
        >
          <div
            className={cn(
              "text-2xl text-textPrimary text-center",
              "md:text-left md:max-w-[280px]",
            )}
          >
            Get started by adding a beneficiary to your account.
          </div>
          <div className="flex items-center justify-center">
            <Button asChild={true} size="md">
              <Link to={addBeneficiaryPath.pattern}>Add Beneficiary</Link>
            </Button>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-6">
          {fiveTwoNineAccounts.map((fiveTwoNineAccount) => (
            <FiveTwoNineAccountsListItem
              key={fiveTwoNineAccount.id}
              fiveTwoNineAccount={fiveTwoNineAccount}
            />
          ))}
          <div className="flex items-center justify-between">
            <div>
              {hasNextPage && endCursor && (
                <button
                  onClick={() => fetchMore(endCursor)}
                  disabled={loading}
                  className="text-neutral-400"
                >
                  View More
                </button>
              )}
            </div>
            <Button asChild={true} size="md">
              <Link to={addBeneficiaryPath.pattern}>Add Beneficiary</Link>
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default FiveTwoNineAccountsList
